export default __webpack_public_path__ + "static/media/Rectangle-131.55f0188f.png";